module.exports = "categories"